import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";

export const useResumeImport = (api, onDone) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return toast.error("That file is over 5 MB. Please upload a smaller file.");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/documents/import", fd);
      toast.success("Resume imported. Check each section, then polish it with AI.");
      onDone(data);
    } catch (err) {
      toast.error(errMsg(err, "Import failed"));
    } finally {
      setBusy(false);
    }
  };

  const picker = (
    <input ref={input} type="file" accept=".pdf,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      className="hidden" onChange={onFile} data-testid="import-file-input" />
  );
  const overlay = busy && (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-paper/80 backdrop-blur-sm" data-testid="import-loading">
      <div className="rounded-2xl border border-paper-border bg-white p-8 text-center shadow-xl">
        <Loader2 className="mx-auto h-8 w-8 animate-spin text-thread" />
        <p className="mt-4 font-serif text-2xl text-ink">Reading your resume…</p>
        <p className="mt-1 text-sm text-ink-soft">This usually takes 10 to 20 seconds.</p>
      </div>
    </div>
  );
  return { open: () => input.current?.click(), picker, overlay, busy, Icon: Upload };
};
